import "core-js/modules/es.array.push.js";
import { ElDialog, ElButton } from "element-plus";
import { CircleCloseFilled } from "@element-plus/icons-vue";
import pixelArtDetails from "./index.vue";
import { Product_Info } from "@/globalcfg";
import i18n from "@/lang";
import { post_Json_elk_statistic } from "@/jsUtils/nodejsRequest";
import EmailPDF from "@/components/tools/emailpdf.vue";
import { useBuildInfoStore } from "@/jsUtils/dataStore";
export default {
  components: {
    ElDialog,
    ElButton,
    CircleCloseFilled,
    pixelArtDetails,
    EmailPDF
  },
  emits: ["onClose", "onClicklike"],
  data() {
    return {
      dialogVisible: false,
      // 拼装控制器相关参数
      buildcontrol: null,
      //拼装控制器
      showBuildDetailPage: false,
      //是否显示拼装详情

      computedDialogWidth: "75%",
      computedDialogTop: "10%"
    };
  },
  props: {
    isdialogVisible: {
      Type: Boolean,
      default: false
    },
    enableBuildDetail: {
      Type: Boolean,
      default: false
    },
    // 传递过来的像素画信息
    // {smallimg: item, 
    // likestatus : false, 
    // unlikestatus: false,  
    // id : id,
    // ldrname:ldrname, 
    // product_type: product_type, 
    // color_numbers: color_numbers}
    piexelImgInfo: {
      Type: Object
    },
    particelImg: {
      Type: Object
    },
    builddata: {
      Type: Object
    }
  },
  watch: {
    isdialogVisible: {
      handler: function (val, oldVal) {
        // console.log("is dialogVisible", val);
        this.dialogVisible = val;
      },
      deep: true
    },
    piexelImgInfo: {
      handler: function (val, oldVal) {
        // console.log("dialgue piexelImgInfo", val);
      },
      deep: true
    },
    dialogVisible: {
      handler: function (val, oldVal) {},
      deep: true
    }
  },
  mounted() {
    this.updateDialogWidth();
    window.addEventListener("resize", this.updateDialogWidth);
  },
  methods: {
    handleclose() {
      // 焦点回到body
      document.body.focus();
      this.dialogVisible = false;
      this.$emit("onClose");
    },
    //点击喜欢
    onClicklike(imaginfo) {
      // console.log("dialog onClicklike ", imaginfo);
      this.$emit("onClicklike", imaginfo);
    },
    onHandleBuyInAmazon() {
      let product_type = this.piexelImgInfo.product_type;
      let product_info = Product_Info[product_type];
      let shopurl = product_info.shopUrl;
      window.location.href = shopurl;
      this.sendElk_Stat_gotoAmazon(product_type);
    },
    // 跳转到详情页
    onHandleDetail() {
      let product_type = this.piexelImgInfo.product_type;
      let product_info = Product_Info[product_type];
      if (!product_info) {
        return;
      }
      let slug = (product_info.key || product_info.path || product_type || '').toLowerCase();
      if (!slug) {
        return;
      }
      this.$router.push({
        path: `/product/${slug}`
      });
      this.dialogVisible = false;
      this.$emit("onClose");
      this.sendElk_Stat_gotoProductDetail(product_type);
    },
    // 统计日志
    sendElk_Stat_gotoAmazon(product) {
      let data = {
        "event": "product_goto_amazon",
        "data": {
          "product_from_path": "home_allpixeart_dialog",
          "product_type": product
        }
      };
      post_Json_elk_statistic(data);
    },
    // 统计跳转到产品页面的日志
    sendElk_Stat_gotoProductDetail(product) {
      let data = {
        "event": "product_click",
        "data": product
      };
      post_Json_elk_statistic(data);
    },
    // 统计点击拼装详情的日志
    sendElk_Stat_gotoBuildDetail(builddata) {
      let static_data = {
        "QRCode": "amalia_main",
        "product_type": builddata.style,
        "image_id": builddata.idname,
        "style": -1
      };
      let data = {
        "event": "image_build",
        "data": static_data
      };
      post_Json_elk_statistic(data);
    },
    // 点击拼装详情页面
    onBuildDetail() {
      let builddata = {
        seqdata: this.builddata,
        idname: this.piexelImgInfo.id,
        smallimg: this.piexelImgInfo.smallimg,
        style: this.piexelImgInfo.product_type
      };
      const buildInfo = builddata;
      const buildInfoStore = useBuildInfoStore();
      if (!buildInfoStore) {
        return;
      }
      let hassaved = buildInfoStore.getBuildInfo();
      if (hassaved) {
        // 清空之前的数据，重新保存
        buildInfoStore.clearBuildInfo();
      }
      buildInfoStore.setBuildInfo(buildInfo);
      this.dialogVisible = false;
      this.$router.push({
        path: "/build_details"
      });
      this.$emit("onClose");
      this.sendElk_Stat_gotoBuildDetail(builddata);
    },
    // 点击获取pdf电子说明书
    onDownloadPDF(imaginfo) {
      this.$refs.emailpdf.showDialog();
    },
    updateDialogWidth() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const aspectRatio = width / height;
      if (aspectRatio > 1.5) {
        // 宽屏
        this.computedDialogWidth = "40%";
      } else if (aspectRatio > 1) {
        // 中等屏幕
        this.computedDialogWidth = "60%";
      } else {
        // 高屏或手机
        this.computedDialogWidth = "80%";
      }

      // 设置最大宽度以防止过宽
      if (this.computedDialogWidth.endsWith('%')) {
        const percentage = parseFloat(this.computedDialogWidth) / 100;
        const maxWidth = 800 * percentage; // 例如基于比例设置
        this.computedDialogWidth = `${Math.min(percentage * width, 800)}px`;
      }
    }
  },
  computed: {
    dialog_titel() {
      // console.log("dialog_titel --- ", this.piexelImgInfo);
      let product_type = this.piexelImgInfo.product_type;
      let product_info = Product_Info[product_type];
      if (i18n.global.locale.value === "zh") {
        return product_info.show_name_zh;
      } else {
        return product_info.show_name;
      }
    },
    eventListeners() {
      // 基础事件监听器
      let listeners = {};
      // 根据条件添加 onBuildDetail 事件监听器
      if (this.enableBuildDetail) {
        listeners.buildDetail = this.onBuildDetail;
        listeners.downloadPDF = this.onDownloadPDF;
      }
      return listeners;
    }
  }
};